import { FC, Fragment, useEffect } from 'react';
import { Transition, Dialog } from '@headlessui/react';
interface PresenterChoiceModalProps {
  isOpen: boolean;
  select: string;
  name: string;
  onClose?: () => void;
}

export const PresenterChoiceModal: FC<PresenterChoiceModalProps> = ({
  isOpen,
  onClose = () => {
    console.warn('please write onClose');
  },
  name,
  select,
}) => {
  useEffect(() => {
    if (isOpen) {
      const timeout = setTimeout(() => {
        onClose?.();
      }, 3000);
      return () => {
        clearTimeout(timeout);
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);
  return (
    <Transition appear show={isOpen} as={Fragment}>
      <Dialog as="div" className="relative z-10" onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black bg-opacity-[0.85]"></div>
        </Transition.Child>
        <div className="fixed inset-0 overflow-y-auto">
          <div className="flex min-h-full justify-center items-center">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 scale-95"
              enterTo="opacity-100 scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 scale-100"
              leaveTo="opacity-0 scale-95"
            >
              <div
                style={{
                  maxWidth: 1280,
                  width: 1280,
                  maxHeight: 800,
                  height: 800,
                  padding: '59px 50px',
                }}
              >
                <Dialog.Panel className="w-full h-full">
                  <p className="text-right text-coral text-p5 ">
                    3초 후 창이 닫힙니다
                  </p>
                  <p className="text-p2 text-white text-center font-medium mt-40">
                    <span className="text-p3">이번 의사결정권자 </span>
                    <strong>{name}</strong>
                    <span className="text-p3"> 님의 선택은</span>
                  </p>
                  <div
                    className="mx-auto rounded-full text-center"
                    style={{
                      width: 176,
                      height: 176,
                      backgroundColor: '#ffed10',
                      marginTop: 46,
                      boxShadow: '0 0 10px 0 rgba(255, 237, 16, 0.7)',
                      padding: 33,
                      paddingTop: 43,
                    }}
                  >
                    <span
                      style={{ fontSize: 110 }}
                      className="font-bold leading-none text-darkBlueGray"
                    >
                      {select}
                    </span>
                  </div>
                </Dialog.Panel>
              </div>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition>
  );
};
